module.exports = __webpack_public_path__ + "static/media/breast-surgery-top-icon.d9ba12fa.svg";